module.exports = __webpack_public_path__ + "static/img/news3.65f28eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news3.png
// module id = 09qX
// module chunks = 1